import { render } from "./AuxLoginView.vue?vue&type=template&id=52407f79&ts=true"
import script from "./AuxLoginView.vue?vue&type=script&lang=ts"
export * from "./AuxLoginView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__